import axiosInstance from './axios';

export const quoteService = {
  getQuotes: async (params = {}) => {
    const response = await axiosInstance.get('/quotes', { params });
    return response.data;
  },

  getQuote: async (id) => {
    const response = await axiosInstance.get(`/quotes/${id}`);
    return response.data;
  },

  createQuote: async (quoteData) => {
    const response = await axiosInstance.post('/quotes', quoteData);
    return response.data;
  },

  updateQuote: async (id, quoteData) => {
    const response = await axiosInstance.put(`/quotes/${id}`, quoteData);
    return response.data;
  },

  deleteQuote: async (id) => {
    const response = await axiosInstance.delete(`/quotes/${id}`);
    return response.data;
  },

  downloadQuotePdf: async (id) => {
    const response = await axiosInstance.get(`/quotes/${id}/pdf`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `quote-${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  convertToSale: async (id, paymentMethod) => {
    const response = await axiosInstance.post(`/quotes/${id}/convert-to-sale`, {
      payment_method: paymentMethod,
    });
    return response.data;
  },
};
